<template>
  <div class="container"  :style="'height:'+containerHeight+'px'">
    <div v-if="!isLoading"
         :class="['course', list.length == 0 ? 'course-null': '']">
      <div v-for="(item, index) in list"
           :key="index"
           class="item">
        <div class="top">
          <img class="course-logo"
               @click="replay(item)"
               :src="item.goodsIndexImg"
               alt="">
          <div class="right">
            <span class="title">{{item.goodsName}}</span>
            <div style="width: 100%">
              <span class="desc"
                    v-html="'共 '+item.sectionNum+' 讲 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 离到期'+item.overdueDay+'天'"></span>
            </div>
            <div style="width: 100%">
              <div class="rate-view">
                <span>学习进度: <span class="rate">{{item.allStudyRate}}%</span></span>
                <a-slider id="test"
                          class="slider"
                          :default-value="item.allStudyRate"
                          :tip-formatter="null"
                          :disabled="true" />
                <!-- <span :class="['replay', item.ordersStatus != 1 ?'overdate': '']"
                      @click="replay(item)"><img src="../../assets/images/course/play.png"
                       alt=""><span>继续学习</span></span> -->

                <a-button :class="['replay','cursor-pointer', item.ordersStatus != 1 ?'overdate': '']"
                          @click="replay(item)"
                          type="primary"
                          shape="circle">
                  <img src="../../assets/images/course/play.png"
                       alt="">
                  <span>继续学习</span>
                </a-button>
              </div>

            </div>

            <div class="bottom" v-if="item.topicNum > 0 || item.examNum>0">
              <div class="section"
                   @click="section(item)" v-if="item.topicNum > 0">
                <div class="section-child cursor-pointer">
                  <img :src="item.ordersStatus != 1 ? require('../../assets/images/course/section_overdate.png'): require('../../assets/images/course/section.png') "
                       alt="">
                  <span>练习</span>
                </div>
              </div>
              <span class="line" v-if="item.topicNum > 0 && item.examNum>0"></span>
              <div class="test"
                   @click="test(item)" v-if="item.examNum>0">
                <div class="section-child cursor-pointer">
                  <img :src="item.ordersStatus != 1 ?require('../../assets/images/course/test_overdate.png'): require('../../assets/images/course/test.png') "
                       alt="">
                  <span>考试</span>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
      <null-data v-if="list.length == 0"
                 :text="'暂无课程'"></null-data>
    </div>

    <div v-if="!isLoading && list.length > 0"
         :style="'height:'+ ' calc(100% - '+ list.length * 280 +'px)'">
    </div>

    <div v-if="!isLoading">
      <CustomFooter></CustomFooter>
    </div>

    <a-spin size="large"
            v-if="isLoading"
            tip="加载中..." />
  </div>
</template>

<script>
import CustomFooter from "../../components/globalComponents/Footer.vue";
import NullData from "../../components/globalComponents/NullData.vue";
import { getMyCourseList, thirdTopicIndex, thirdExamIndex } from "../../assets/api/api";
export default {
  name: 'MyCourse',
  components: {
    CustomFooter,
    NullData
  },
  data () {
    return {
      list: [],
      isLoading: true,
      containerHeight: 0
    }
  },
  mounted () {
     this.containerHeight = document.documentElement.clientHeight - 80
    this.fatchData()
  },
  methods: {
    fatchData () {
      this.getMyCourseList()
    },
    getMyCourseList () {
      const params = {
        userId: localStorage.getItem('userId')
      }
      getMyCourseList(params).then(res => {
        this.list = res.data
      }).catch((err) => {
      }).finally(() => {
        this.isLoading = false
      })
    },
    replay (item) {
      // console.log(item)
      this.$router.push({ name: 'GoodsPlay', query: {goodsId: item.goodsId } })
    },
    section (item) {
      const params = {
        uId: localStorage.getItem('userId'),
        goodsId: item.goodsId
      }
      thirdTopicIndex(params).then(res => {
        this.$router.push({ name: 'GoodsPlay', query: { iframeUrl: res } })

      }).catch((err) => {
      }).finally(() => {
      })
    },
    test (item) {
      const params = {
        uId: localStorage.getItem('userId'),
        goodsId: item.goodsId
      }
      thirdExamIndex(params).then(res => {
        this.$router.push({ name: 'GoodsPlay', query: { iframeUrl: res } })
      }).catch((err) => {
      }).finally(() => {
      })
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .ant-slider-disabled .ant-slider-handle {
  background-color: #1ac0c4;
  border-color: #d1f2f3 !important;
}
/deep/ .ant-slider-disabled .ant-slider-track {
  background-color: #1ac0c4 !important;
}

/deep/ .ant-slider-rail {
  background-color: #d1f2f3;
}

/deep/ .ant-slider {
  margin-bottom: 0px;
  margin-top: 10px;
}
.container {
  flex-direction: column;
  background: #f5f5f5;
  height: 100%;
  min-height: 100%;
  overflow-y: auto;
  .course-null {
    min-height: calc(100% - 1.68rem);
  }
  .course {
    /*width: 1200px;*/
    width: 90%;
    margin: 0 auto;
    height: auto;
    // min-height: calc(100% - 1.68rem);
    .item {
      background: #ffffff;
      border-radius: 5px;
      margin-top: 30px;
      padding: 30px;
      box-sizing: border-box;
      .course-logo {
        width: 283px;
        height: 189px;
        object-fit: cover;
        border-radius: 10px;
      }

      .bottom {
        display: flex;
        justify-content: flex-start;
        margin-top: 0px;
        color: #333333;
        font-size: 20px;
        align-items: center;
        // margin-left: 200px;
        img {
          width: 40px;
          height: 40px;
          margin-right: 16px;
        }

        .line {
          width: 1px;
          height: 40px;
          background-color: #e8e8e8;
        }

        .section {
          width: 200px;
          text-align: left;
        }

        .test {
          width: 200px;
          text-align: center;

          .section-child {
            margin-left: 40px;
          }
        }

        .section-child {
          width: 120px;
          padding: 5px;
        }

        .section-child:hover {
          border-radius: 3px;
          background-color: #ffffff;
          box-shadow: 0px 2px 6px 0px rgba(26, 192, 196, 0.15);
        }
      }

      .top {
        display: flex;
        .right {
          margin-left: 30px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
          .title {
            color: #333333;
            font-weight: 500;
            font-size: 24px;
          }

          .desc {
            font-size: 20px;
            color: #666666;
          }

          .rate-view {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            font-size: 20px;
            color: #666666;
          }

          .slider {
            flex: 1;
            margin: 0 30px;
          }

          .rate {
            color: #1ac0c4;
          }

          .replay {
            width: 118px;
            height: 34px;
            background: #1ac0c4;
            border-radius: 20px;
            color: #ffffff;
            text-align: center;
            line-height: 34px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 15px;
            font-weight: 500;
            border: 0;
            img {
              width: 12px;
              height: 16px;
              margin-right: 10px;
            }
          }

          .replay:hover {
            opacity: 0.8;
          }

          .overdate {
            background: #c5c5c5;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  /* 在屏幕宽度大于等于 1200px 时，覆盖默认的宽度 */
  .container {
    .course {
      width: 1200px;
    }
  }
}
</style>
